import React, {useState, useRef, useEffect} from 'react'
import {Container} from 'react-bootstrap'
import {useHistory} from 'react-router-dom'
import './style.css'

export default function Checkpembayaran() {
    const [timerHouse, setTimerHouse] = useState('0')
    const [timerMinuts, setTimerMinuts] = useState('0')
    const [timerSecons, setTimerSecons] = useState('0')

    const history = useHistory()

    const handleClick = () => {
        history.push('/transaksi')
    }

    let interval = useRef()

    const startTimer = () => {
        const countDownDate = new Date('september 12, 2021 00:00:00').getTime()

        interval = setInterval(() => {
            const now = new Date().getTime()
            const distance = countDownDate - now;

            const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
            const minuts = Math.floor((distance % (1000 * 60 * 60 )) / (1000 * 60 ))
            const secons = Math.floor((distance % (1000 * 60 )) / 1000)

            if(distance < 0) {
                clearInterval(interval.current)
            } else {
                setTimerHouse(hours)
                setTimerMinuts(minuts)
                setTimerSecons(secons)
            }
        }, 1000)
    }

    useEffect(() => {
        startTimer();
    })

    return (
        <Container className="check-pembayaran-malmora">
        <div className="title">
            <img onClick={handleClick} src="asset/dashboard/icons/arr-left.svg" alt="left" />
            <h5>Alamat Pengirim</h5>
        </div>
            <h3>Pembayaran</h3>
            <div className="detail-check">
                <h6>Detail Pembayaran</h6>
                <p>Total Pembayaran</p>
                <h5>Rp. 200.000</h5>
            </div>
            <div className="time-detail">
                <p>Batas Waktu Membayar</p>
                <div className="timer">
                   <h2>{timerHouse}<span>Jam</span> :</h2>
                   <h2>{timerMinuts}<span>Menit</span> :</h2>
                   <h2>{timerSecons}<span>Detik</span></h2>
                </div>
                <p>Otomatis dibatalkan jika tidak membayar setelah 12 Agustus 2021, 15:51</p>
            </div>
            <p>Pembayaran dikirim ke</p>
            <div className="ber-check-rekening">
                <p>Bank BSI</p>
                <h4>(422) 7230481081</h4>
            </div>
            <p>Upload Bukti Pembayaran</p>       
            <input type="file" class="form-input-file" />
            <div className="button">
                <button type="button">Kirim</button>
            </div>
            <br /><br />
            <div className="text-center">
                2020 Malmora
            </div>
            </Container>
    )
}
